import { TextField } from "@mui/material";
import { MRT_Row, MRT_RowData } from "material-react-table";
import React, { useCallback } from "react";

type CustomPrecioInputProps<T extends MRT_RowData> = {
  row: MRT_Row<T>
  value: number | string
  handleValue: (value: string) => void;
}

const CustomPrecioInput = <T extends MRT_RowData>({
  row,
  value,
  handleValue
}: CustomPrecioInputProps<T>) => {

  const onHandleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {

      let newValue = e.target.value.trim().replace(",", ".");
      // Solo permitir números positivos con o sin decimales
      //if (!/^\d*\.?\d*$/.test(newValue)) return;
      if (!/^\d*(\.\d{0,4})?$/.test(newValue)) return; ///aqui debo cambiar para decimales



      if (newValue == ".") {
        newValue = "0."
      }
      if (newValue.startsWith("0") &&!newValue.startsWith("0.")&& newValue.length > 1) {
        newValue = newValue.replace(/^0+/, "")
        //console.log(newValue)
      }
      if (newValue === "") {
        newValue = "0"
      }

      handleValue((newValue))
    },
    [handleValue, row.original]
  )
  return (
    <TextField
      value={value || '0'}
      type="text"
      size="small"
      variant="outlined"
      inputProps={{ min: 0, step: 1, inputMode: 'decimal' }}
      /*       inputProps={{
              inputMode: "decimal"
            }} */
      onChange={onHandleChange}
    />
  )
}
export default CustomPrecioInput